export const common = {
  // Navigation
  home: 'الرئيسية',
  services: 'الخدمات',
  projects: 'المشاريع',
  team: 'الفريق',
  pricing: 'الأسعار',
  faq: 'الأسئلة الشائعة',
  contact: 'اتصل بنا',
  backToHome: 'العودة للرئيسية',
  
  // Hero Section
  heroTag: 'حلول برمجية مبتكرة لأعمالك',
  heroTitle1: 'تصحيح، تطوير، نشر',
  heroTitle2: 'بثقة تامة',
  heroDescription: 'نحول أفكارك إلى منتجات رقمية قوية باستخدام أحدث التقنيات وفرق تطوير متخصصة',
  startProject: 'ابدأ مشروعك',
  exploreServices: 'استكشف الخدمات',
  projectsCompleted: 'مشروع مكتمل',
  clientSatisfaction: 'رضا العملاء',
  aiSupport: 'دعم الذكاء الاصطناعي متاح',
  
  // Services Section
  ourServices: 'خدماتنا',
  servicesTitle: 'حلول تطوير شاملة',
  servicesDescription: 'من تصحيح الأخطاء إلى النشر، نقدم مجموعة كاملة من الخدمات لمساعدتك في بناء وصيانة برامج استثنائية.',
  
  service1Title: 'إصلاح الأخطاء وتصحيحها',
  service1Description: 'خدمات تصحيح احترافية لتحديد وإصلاح المشاكل بسرعة. يستخدم فريقنا أدوات متقدمة ومساعدة الذكاء الاصطناعي لحل الأخطاء بكفاءة.',
  service1Feature1: 'تحليل الكود',
  service1Feature2: 'تتبع الأخطاء',
  service1Feature3: 'اختبار الأداء',
  service1Feature4: 'تحليل السبب الجذري',
  
  service2Title: 'التطوير المخصص',
  service2Description: 'بناء تطبيقات وميزات مخصصة تناسب احتياجاتك. من تطبيقات الويب إلى حلول الهاتف المحمول، نقدم كود عالي الجودة.',
  service2Feature1: 'تطبيقات الويب',
  service2Feature2: 'تطبيقات الهاتف',
  service2Feature3: 'تطوير API',
  service2Feature4: 'تصميم قواعد البيانات',
  
  service3Title: 'الخدمات السحابية',
  service3Description: 'الترحيل السحابي والنشر والإدارة باستخدام منصات AWS و Azure و Google Cloud',
  service3Feature1: 'الترحيل السحابي',
  service3Feature2: 'إعداد البنية التحتية',
  service3Feature3: 'حلول قابلية التوسع',
  service3Feature4: 'مراقبة السحابة',
  
  service4Title: 'أتمتة مكان العمل',
  service4Description: 'أتمتة المهام المتكررة وسير العمل لتعزيز الإنتاجية. نصوص وأدوات مخصصة مصممة لاحتياجاتك الخاصة.',
  service4Feature1: 'أتمتة المهام',
  service4Feature2: 'تكامل سير العمل',
  service4Feature3: 'معالجة البيانات',
  service4Feature4: 'إنشاء التقارير',
  
  service5Title: 'تحسين الأداء',
  service5Description: 'تحسين تطبيقاتك للسرعة والكفاءة. تحليل شامل وتحسينات لتجربة مستخدم أفضل.',
  service5Feature1: 'تقليل وقت التحميل',
  service5Feature2: 'تحسين قاعدة البيانات',
  service5Feature3: 'إعادة هيكلة الكود',
  service5Feature4: 'استراتيجيات التخزين المؤقت',
  
  service6Title: 'تدقيق الأمان',
  service6Description: 'مراجعات أمنية شاملة لحماية تطبيقاتك. تحديد الثغرات وتطبيق أفضل الممارسات.',
  service6Feature1: 'فحص الثغرات',
  service6Feature2: 'مراجعة الكود',
  service6Feature3: 'تصحيحات الأمان',
  service6Feature4: 'فحص الامتثال',
  
  // Why Choose Section
  whyChooseTitle: 'لماذا تختار Debug؟',
  whyChooseDescription: 'نجمع بين الخبرة التقنية والرؤية التجارية لتقديم حلول برمجية استثنائية',
  
  whyFeature1Title: 'فريق خبير',
  whyFeature1Description: 'مطورون ومصممون ومهندسون ذوو مهارات عالية مع سنوات من الخبرة في الصناعة',
  
  whyFeature2Title: 'التسليم في الوقت المحدد',
  whyFeature2Description: 'ملتزمون بالوفاء بالمواعيد النهائية من خلال إدارة المشاريع وعمليات التطوير الفعالة',
  
  whyFeature3Title: 'دعم مخصص',
  whyFeature3Description: 'دعم تقني مستمر وصيانة لضمان تشغيل برامجك بسلاسة',
  
  whyFeature4Title: 'ضمان الجودة',
  whyFeature4Description: 'اختبار صارم ومراقبة الجودة لتقديم حلول موثوقة وعالية الأداء',
  
  // Projects Section
  ourWork: 'أعمالنا',
  projectsTitle: 'قصص النجاح والمشاريع',
  projectsDescription: 'استكشف محفظة مشاريعنا الناجحة عبر مختلف الصناعات والتقنيات.',
  
  // Project Filters
  filterAll: 'الكل',
  filterWeb: 'ويب',
  filterMobile: 'موبايل',
  filterEnterprise: 'المؤسسات',
  
  web1Title: 'شركة شمال أفريقيا للزراعة',
  web1Category: 'تطوير مواقع ويب',
  web1Description: 'موقع إلكتروني لشركة متخصصة في الحلول الزراعية المستدامة، يعرّف بخدمات الشركة ومنتجاتها ويسلط الضوء على خبراتها ومساهمتها في تطوير القطاع الزراعي في شمال أفريقيا.',
  
  web2Title: 'نشتري سيارتك - ألمانيا',
  web2Category: 'تطوير مواقع ويب',
  web2Description: 'منصة ألمانية تشتري السيارات المستعملة مباشرة من العملاء مع تقييم فوري عبر الإنترنت، دفع آمن، وخدمة استلام مجانية',
  
  web3Title: 'أكاديمية هوريكا سمارت',
  web3Category: 'تطوير مواقع ويب',
  web3Description: 'منصة لأكاديمية تدريب متخصصة في مجال الضيافة (HORECA)، تقدم دورات احترافية في الأغذية والمشروبات وإدارة المطاعم.',
  
  mobile1Title: 'تطبيق 5vix System',
  mobile1Category: 'تطوير تطبيقات الهاتف',
  mobile1Description: 'تطبيق مصمم بعناية لتعزيز أدائك، وتحقيق أفضل النتائج، ودفعك نحو نجاح استثنائي.',

  mobile2Title: 'تطبيق Texio ERP',
  mobile2Category: 'تطوير تطبيقات موبايل',
  mobile2Description: 'Texio هو نظام إدارة قوي مصمم خصيصًا لمصانع النسيج.',
  
  mobile3Title: 'هوريكا إن',
  mobile3Category: 'تطوير تطبيقات موبايل',
  mobile3Description: 'تطبيق موبايل يربط بين الباحثين عن عمل وأصحاب المطاعم في مجال الضيافة، ويتيح تصفح الوظائف والتقديم عليها مباشرة.',
  
  mobile4Title: '5vix Fit',
  mobile4Category: 'تطوير تطبيقات موبايل',
  mobile4Description: 'التطبيق الرسمي لأعضاء جيم فايفيكس، يتيح للأعضاء متابعة اشتراكاتهم وحضورهم والاطلاع على أنشطة الجيم بسهولة، كل ذلك في مكان واحد.',

  enterprise1Title: 'نظام 5vix لإدارة الجيم',
  enterprise1Category: 'حلول مؤسسية',
  enterprise1Description: 'منصة شاملة لإدارة الأعضاء والاشتراكات وجدولة الحصص في الصالات الرياضية',
  
  enterprise2Title: 'نظام (ERP) لمصانع المنسوجات',
  enterprise2Category: 'حلول مؤسسية',
  enterprise2Description: 'نظام متكامل مصمم خصيصًا لصناعة النسيج، يساعدك على إدارة الإنتاج والمخزون والمبيعات والمشتريات والعمليات من خلال منصة موحدة ومتكاملة.',

  enterprise3Title: 'وكيل ذكاء اصطناعي للواتساب',
  enterprise3Category: 'حلول مؤسسية',
  enterprise3Description: 'ردود ذكية ورسائل جماعية وتحليلات عميقة — منصة واحدة تدير كل محادثاتك باحترافية.',
  
  enterprise4Title: 'تحليل طبي بالذكاء الاصطناعي',
  enterprise4Category: 'حلول مؤسسية',
  enterprise4Description: 'نظام ذكي للتصوير الطبي للكشف الآلي عن الكسور، وخشونة المفاصل، واضطرابات الرئة، والجنف، وأمراض الأسنان.',

  
  // What We Do Section
  whatWeDo: 'ما نقوم به',
  whatWeDoTag: 'خبراتنا',
  whatWeDoTitle: 'ما نقوم به',
  whatWeDoDescription: 'نبني حلولاً رقمية ذكية، ونؤتمت سير العمل، ونساعد الشركات على النمو بشكل أسرع باستخدام أحدث التقنيات.',
  whatWeDoPillar1Title: 'حلول رقمية ذكية',
  whatWeDoPillar1Description: 'نصمم ونطور برمجيات مخصصة تحل تحديات الأعمال الحقيقية. من منصات الويب إلى تطبيقات الهاتف المحمول، كل منتج مبني للأداء والقابلية للتوسع والنمو طويل المدى.',
  whatWeDoPillar1Feature1: 'تطبيقات ويب وموبايل مخصصة',
  whatWeDoPillar1Feature2: 'تكامل API والأنظمة',
  whatWeDoPillar1Feature3: 'ميزات مدعومة بالذكاء الاصطناعي',
  whatWeDoPillar1Feature4: 'بنية تحتية قابلة للتوسع',
  whatWeDoPillar2Title: 'أتمتة سير العمل',
  whatWeDoPillar2Description: 'نتخلص من المهام المتكررة ونسهل العمليات من خلال أتمتة العمليات الأساسية، مما يتيح لفريقك التركيز على العمل الأعلى قيمة.',
  whatWeDoPillar2Feature1: 'أتمتة المهام والعمليات',
  whatWeDoPillar2Feature2: 'تكامل خطوط البيانات',
  whatWeDoPillar2Feature3: 'أنظمة إعداد التقارير الذكية',
  whatWeDoPillar2Feature4: 'المزامنة المتكاملة عبر المنصات',
  whatWeDoPillar3Title: 'نمو فعال',
  whatWeDoPillar3Description: 'نساعد الشركات على النمو دون عوائق. من البنية التحتية إلى التحسين، نضمن أن الأنظمة مبنية للتوسع بشكل موثوق وآمن وفعال من حيث التكلفة.',
  whatWeDoPillar3Feature1: 'إعداد البنية التحتية السحابية',
  whatWeDoPillar3Feature2: 'تحسين الأداء',
  whatWeDoPillar3Feature3: 'الأمان والامتثال',
  whatWeDoPillar3Feature4: 'دعم وصيانة مستمرة',
  whatWeDoCtaTitle: 'هل أنت مستعد لتحويل أعمالك؟',
  whatWeDoCtaDescription: 'دعنا نبني الأساس الرقمي الذي يدفع نموك — من الفكرة إلى التنفيذ.',
  
  // Team Section
  ourTeam: 'فريقنا',
  teamTitle: 'تعرف على الخبراء',
  teamDescription: 'فريقنا الموهوب من المطورين والمهندسين والمتخصصين المكرسين لتقديم نتائج استثنائية.',
  
  member1Name: 'رشاد البنّا',
  member1Role: 'الرئيس التنفيذي ومؤسس',
  member1Bio: 'أكثر من 9 سنوات خبرة في تطوير البرمجيات وقيادة الأعمال',
  
  member2Name: 'فتحي درويش',
  member2Role: 'المدير التقني ومؤسس',
  member2Bio: 'تقديم حلول رقمية قابلة للتوسع وذات تأثير كبير، مع التركيز على الابتكار العملي والقيمة المستدامة',
  
  member3Name: 'محمود يعقوت',
  member3Role: 'مطور برمجيات',
  member3Bio: 'تطوير تطبيقات موبايل عالية الأداء مع خبرة في الحلول متعددة المنصات والميزات الأصلية',
  
  member4Name: 'رقية نبيل',
  member4Role: 'منسقة بيانات',
  member4Bio: 'متخصصة في جمع البيانات وتنظيمها والتواصل مع العملاء لضمان سجلات دقيقة ومحدثة',
  
  member5Name: 'فريدة سعيد',
  member5Role: 'مصممة تجربة المستخدم / واجهة المستخدم',
  member5Bio: 'مصممة مبدعة بخبرة في إنشاء تجارب مستخدم بديهية وجذابة',

  // Pricing Section
  pricingPlans: 'خطط الأسعار',
  pricingTitle: 'أسعار بسيطة وشفافة',
  pricingDescription: 'اختر الخطة التي تناسب احتياجاتك. جميع الخطط تشمل ضمان الجودة وضمان الرضا.',
  
  plan1Name: 'المبتدئ',
  plan1Price: '99',
  plan1Period: 'لكل مشروع',
  plan1Description: 'مثالي لإصلاحات الأخطاء الصغيرة والتحسينات السريعة',
  
  plan2Name: 'المحترف',
  plan2Price: '299',
  plan2Period: 'لكل مشروع',
  plan2Description: 'مثالي للتطوير المخصص والميزات المعقدة',
  mostPopular: 'الأكثر شعبية',
  
  plan3Name: 'المؤسسات',
  plan3Price: 'مخصص',
  plan3Period: 'اتصل بنا',
  plan3Description: 'حلول شاملة للمشاريع واسعة النطاق',
  
  planFeature1: 'إصلاح الأخطاء والتصحيح',
  planFeature2: 'مراجعة الكود',
  planFeature3: 'تحليل الأداء',
  planFeature4: 'دعم البريد الإلكتروني',
  planFeature5: 'وقت استجابة 48 ساعة',
  planFeature6: 'توثيق أساسي',
  planFeature7: 'كل ما في المبتدئ',
  planFeature8: 'التطوير المخصص',
  planFeature9: 'توليد الكود بالذكاء الاصطناعي',
  planFeature10: 'دعم ذو أولوية',
  planFeature11: 'وقت استجابة 24 ساعة',
  planFeature12: 'توثيق مفصل',
  planFeature13: 'تحسين الكود',
  planFeature14: 'تدقيق أمني',
  planFeature15: 'كل ما في المحترف',
  planFeature16: 'فريق مخصص',
  planFeature17: 'أتمتة مكان العمل',
  planFeature18: 'دعم 24/7',
  planFeature19: 'استجابة فورية',
  planFeature20: 'توثيق كامل',
  planFeature21: 'صيانة مستمرة',
  planFeature22: 'تدريب واستشارة',
  planFeature23: 'اتفاقية مستوى خدمة مخصصة',
  
  getStarted: 'ابدأ الآن',
  customSolution: 'هل تحتاج إلى حل مخصص؟ نحن هنا للمساعدة.',
  contactQuote: 'اتصل بنا للحصول على عرض أسعار مخصص ←',
  
  // FAQ Section
  faqTag: 'الأسئلة الشائعة',
  faqTitle: 'الأسئلة المتكررة',
  faqDescription: 'ابحث عن إجابات للأسئلة الشائعة حول خدماتنا وعملياتنا.',
  
  faq1Question: 'ما مدى سرعة إصلاح الأخطاء في تطبيقي؟',
  faq1Answer: 'يعتمد وقت استجابتنا على تعقيد المشكلة وإلحاحها. بالنسبة للأخطاء الحرجة، يمكننا البدء في العمل في غضون ساعات. يتم إكمال معظم إصلاحات الأخطاء في غضون 24-48 ساعة. نقدم دعماً ذا أولوية للمشاكل العاجلة.',
  
  faq2Question: 'ما هي التقنيات والأطر التي تعملون بها؟',
  faq2Answer: 'نعمل مع مجموعة واسعة من التقنيات الحديثة لتقديم حلول برمجية متكاملة، بما في ذلك الواجهات الأمامية: React، Vue، Angular، HTML5، CSS3، CSS، Bootstrap، jQuery؛ الواجهات الخلفية: Node.js، Express.js، Python (Django, Flask)، Java (Spring Boot)، PHP (Laravel, Symfony)؛ تطبيقات الهواتف المحمولة: React Native، Flutter، Swift، Kotlin؛ منصات السحابة: AWS، Microsoft Azure، Google Cloud Platform، Firebase، DigitalOcean؛ قواعد البيانات والتخزين: MySQL، PostgreSQL، MongoDB، Firebase Firestore، Oracle، Microsoft SQL Server؛ أدوات التطوير والبرمجة: Docker، Git / GitHub / GitLab، Jenkins، CircleCI، Terraform، CI/CD، RESTful APIs، GraphQL، WebSockets؛ أدوات التصميم وتجربة المستخدم: Figma، Adobe XD، Sketch، InVision، Zeplin',
  
  faq3Question: 'هل تقدمون صيانة ودعم مستمر؟',
  faq3Answer: 'نعم، نقدم حزم صيانة مستمرة مصممة خصيصاً لاحتياجاتك. يشمل ذلك التحديثات المنتظمة والتصحيحات الأمنية ومراقبة الأداء والدعم الفني. يمكننا إنشاء خطة صيانة مخصصة بناءً على متطلباتك.',
  
  faq4Question: 'كيف يعمل توليد الكود المدعوم بالذكاء الاصطناعي؟',
  faq4Answer: 'تقوم أدوات الذكاء الاصطناعي لدينا بتحليل متطلباتك وقاعدة الكود الموجودة لتوليد كود محسّن وجاهز للإنتاج. هذا يسرع وقت التطوير مع الحفاظ على معايير الجودة العالية. يتم مراجعة جميع الأكواد المولدة بالذكاء الاصطناعي من قبل مطورينا الخبراء قبل التسليم.',
  
  faq5Question: 'ما هو نموذج التسعير الخاص بكم؟',
  faq5Answer: 'نقدم أسعاراً مرنة بناءً على نطاق المشروع وتعقيده. يمكنك الاختيار من بين حزمنا القياسية أو طلب عرض أسعار مخصص للمشاريع الأكبر. جميع الأسعار شفافة بدون رسوم خفية، ونقدم تقديرات مفصلة قبل بدء العمل.',
  
  faq6Question: 'هل توقعون اتفاقيات عدم إفشاء وتحمون الملكية الفكرية؟',
  faq6Answer: 'بالتأكيد. نحن نأخذ السرية على محمل الجد ويسعدنا توقيع اتفاقيات عدم الإفشاء قبل مناقشة مشروعك. يتم نقل جميع حقوق الكود والملكية الفكرية إليك عند اكتمال المشروع. نحافظ على بروتوكولات أمان صارمة لحماية بياناتك.',
  
  faq7Question: 'ما هي الأنظمة والحلول الجاهزة التي تقدمها منصة Debug لقطاعات الأعمال؟',
  faq7Answer: 'توفر منصة Debug خمسة أنظمة متكاملة جاهزة للإنتاج: (1) نظام 5vix لإدارة الصالات الرياضية والاشتراكات، (2) تطبيق 5vix Fit لمتابعة تدريبات الأعضاء، (3) نظام Texio ERP المتخصص في إدارة مصانع الغزل والنسيج والملابس، (4) وكيل ذكاء اصطناعي للواتساب (Debug / Wyzon) لأتمتة خدمة العملاء والمبيعات 24/7، و(5) منصة AI-Medical للكشف والتصوير الطبي الذكي.',
  
  faq8Question: 'كيف تضمنون جودة الكود وسرعة حل المشكلات البرمجية؟',
  faq8Answer: 'نتبع منهجية تحليل السبب الجذري (Root Cause Analysis) بدلاً من الحلول المؤقتة، مع كتابة اختبارات آلية، ومراجعة أمان الكود وفق معايير OWASP العالمية. يبدأ مهندسونا بالتشخيص خلال ساعتين من الإبلاغ لمعظم الحالات الطارئة مع تقديم تقرير فني شامل.',
  
  stillQuestions: 'لا تزال لديك أسئلة؟',
  stillQuestionsDescription: 'لا يمكنك العثور على الإجابة التي تبحث عنها؟ فريقنا هنا للمساعدة.',
  contactSupport: 'اتصل بالدعم',
  
  // Contact Section
  getInTouch: 'تواصل معنا',
  ctaTitle: 'هل أنت مستعد لبدء مشروعك؟',
  ctaDescription: 'دعنا نناقش كيف يمكننا مساعدتك في بناء وتصحيح وتحسين تطبيقاتك. فريقنا جاهز لتحويل أفكارك إلى واقع.',
  
  emailUs: 'راسلنا عبر البريد',
  callUs: 'اتصل بنا',
  availability: 'التوفر',
  availabilityText: 'دعم الذكاء الاصطناعي متاح 24/7',
  
  fullName: 'الاسم الكامل',
  emailAddress: 'عنوان البريد الإلكتروني',
  companyName: 'اسم الشركة',
  projectDetails: 'تفاصيل المشروع',
  sendMessage: 'إرسال الرسالة',
  sending: 'جاري الإرسال...',
  thankYou: 'شكراً لك! سنعود إليك قريباً.',
  
  // Flagship Systems & Smart Routing
  flagshipSectionTag: 'الأنظمة والحلول الرائدة',
  flagshipTitle: 'أنظمة تشغيلية متكاملة لقطاعات الأعمال',
  flagshipDescription: 'منتجات جاهزة للإنتاج تخدم قطاعات النوادي الرياضية، مصانع النسيج، الرعاية الصحية، وأتمتة خدمة العملاء بالذكاء الاصطناعي.',
  launchSystem: 'تشغيل واستكشاف النظام',
  exploreSystem: 'استكشف النظام',
  downloadApp: 'تحميل التطبيق',
  visitWebPlatform: 'منصة الويب السحابية',
  interestedSystem: 'المنتج أو النظام المطلوب',
  systemGeneral: 'خدمات برمجية مخصصة وتصحيح أخطاء عامة',
  systemWhatsappAi: 'وكيل ذكاء اصطناعي للواتساب (Debug / Wyzon)',
  system5vixGym: 'نظام 5vix لإدارة الجيم والنوادي',
  system5vixFit: 'تطبيق 5vix Fit للأعضاء والمتدربين',
  systemAiMedical: 'تحليل طبي بالذكاء الاصطناعي (5vix AI)',
  systemTextileErp: 'نظام ERP لمصانع النسيج (Texio)',
  recommendedProductBadge: 'حل برمجي مقترح لهذا المقال',
  
  // Footer
  footerDescription: 'حلول تصحيح وتطوير احترافية مدعومة بتقنية الذكاء الاصطناعي والمحترفين ذوي الخبرة.',
  servicesFooter: 'الخدمات',
  bugFixing: 'إصلاح الأخطاء والتصحيح',
  customDev: 'التطوير المخصص',
  cloudServices: 'الخدمات السحابية',
  aiCodeGen: 'توليد الكود بالذكاء الاصطناعي',
  workplaceAuto: 'أتمتة مكان العمل',
  perfOptimization: 'تحسين الأداء',
  
  company: 'الشركة',
  aboutUs: 'من نحن',
  ourWorkFooter: 'أعمالنا',
  pricingFooter: 'الأسعار',
  faqFooter: 'الأسئلة الشائعة',
  contactFooter: 'اتصل بنا',
  
  contactInfo: 'معلومات الاتصال',
  copyright: '© 2025 Debug. جميع الحقوق محفوظة',
  privacyPolicy: 'سياسة الخصوصية',
  termsOfService: 'شروط الخدمة',
  poweredBy: 'مدعوم بواسطة Debug',

  // Privacy Policy
  lastUpdated: "آخر تحديث",
  introductionTitle: "المقدمة",
  introductionText: "في Debuging، نحن ملتزمون بحماية خصوصيتك وضمان أمان معلوماتك الشخصية. توضح سياسة الخصوصية هذه كيفية جمع واستخدام والكشف عن معلوماتك وحمايتها عند زيارة موقعنا أو استخدام خدماتنا.",
  informationWeCollect: "المعلومات التي نجمعها",
  informationWeCollectText: "نجمع المعلومات التي تقدمها لنا مباشرة، بما في ذلك:",
  personalInfo: "المعلومات الشخصية مثل الاسم والبريد الإلكتروني ورقم الهاتف",
  technicalInfo: "المعلومات التقنية حول جهازك ونشاط التصفح",
  usageData: "بيانات الاستخدام والتحليلات حول كيفية تفاعلك مع خدماتنا",
  howWeUseInfo: "كيف نستخدم معلوماتك",
  howWeUseInfoText: "نستخدم المعلومات التي نجمعها من أجل:",
  provideServices: "توفير وصيانة وتحسين خدماتنا",
  improveServices: "تطوير ميزات ووظائف جديدة",
  communicateWithYou: "التواصل معك حول خدماتنا",
  sendUpdates: "إرسال التحديثات والنشرات الإخبارية والمواد التسويقية",
  protectRights: "حماية حقوقنا ومنع الاحتيال",
  dataSecurity: "أمان البيانات",
  dataSecurityText: "نطبق تدابير تقنية وتنظيمية مناسبة لحماية معلوماتك الشخصية من الوصول غير المصرح به أو التعديل أو الكشف أو التدمير. ومع ذلك، لا توجد طريقة نقل عبر الإنترنت آمنة بنسبة 100٪.",
  thirdPartyServices: "خدمات الطرف الثالث",
  thirdPartyServicesText: "قد نستخدم مزودي خدمات خارجيين لمساعدتنا في تشغيل أعمالنا وتقديم الخدمات لك. يمكن لهؤلاء المزودين الوصول إلى معلوماتك فقط لأداء مهام محددة نيابة عنا وملزمون بحماية معلوماتك.",
  yourRights: "حقوقك",
  yourRightsText: "لديك الحق في:",
  accessData: "الوصول إلى بياناتك الشخصية والحصول على نسخة منها",
  correctData: "تصحيح المعلومات غير الدقيقة أو غير الكاملة",
  deleteData: "طلب حذف معلوماتك الشخصية",
  restrictProcessing: "تقييد أو الاعتراض على معالجة بياناتك",
  dataPortability: "طلب نقل البيانات",
  cookies: "ملفات تعريف الارتباط والتتبع",
  cookiesText: "نستخدم ملفات تعريف الارتباط وتقنيات التتبع المماثلة لتتبع النشاط على موقعنا وتخزين معلومات معينة. يمكنك توجيه متصفحك لرفض جميع ملفات تعريف الارتباط أو للإشارة عند إرسال ملف تعريف ارتباط.",
  changesToPolicy: "التغييرات على هذه السياسة",
  changesToPolicyText: "قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سنخطرك بأي تغييرات عن طريق نشر سياسة الخصوصية الجديدة على هذه الصفحة وتحديث تاريخ 'آخر تحديث'.",
  contactUs: "اتصل بنا",
  contactUsText: "إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى الاتصال بنا:",
  email: "البريد الإلكتروني",
  phone: "الهاتف",

  // Terms of Service
  acceptanceOfTerms: "قبول الشروط",
  acceptanceOfTermsText: "من خلال الوصول إلى خدمات Debuging واستخدامها، فإنك تقبل وتوافق على الالتزام بشروط وأحكام هذه الاتفاقية. إذا كنت لا توافق على هذه الشروط، يرجى عدم استخدام خدماتنا.",
  servicesDescriptionText: "تقدم Debuging خدمات تطوير البرمجيات وتطوير الويب وتطوير تطبيقات الهاتف المحمول والحلول السحابية والاستشارات التقنية. نحتفظ بالحق في تعديل أو تعليق أو إيقاف أي جانب من جوانب خدماتنا في أي وقت.",
  userResponsibilities: "مسؤوليات المستخدم",
  userResponsibilitiesText: "كمستخدم لخدماتنا، فإنك توافق على:",
  provideAccurateInfo: "تقديم معلومات دقيقة وكاملة",
  maintainSecurity: "الحفاظ على أمان بيانات اعتماد حسابك",
  complyWithLaws: "الامتثال لجميع القوانين واللوائح المعمول بها",
  notMisuse: "عدم إساءة استخدام خدماتنا أو إساءة استخدامها",
  intellectualProperty: "الملكية الفكرية",
  intellectualPropertyText: "جميع المحتويات والميزات والوظائف الخاصة بخدماتنا مملوكة لـ Debuging ومحمية بموجب قوانين حقوق النشر والعلامات التجارية والملكية الفكرية الدولية الأخرى. لا يجوز لك إعادة إنتاج أو توزيع أو إنشاء أعمال مشتقة دون إذن كتابي صريح منا.",
  paymentTerms: "شروط الدفع",
  paymentTermsText: "يتم الاتفاق على شروط الدفع قبل بدء المشروع. جميع الرسوم غير قابلة للاسترداد ما لم ينص على خلاف ذلك كتابيًا. قد تؤدي المدفوعات المتأخرة إلى تعليق الخدمات ورسوم إضافية.",
  limitationOfLiability: "تحديد المسؤولية",
  limitationOfLiabilityText: "لن تكون Debuging مسؤولة عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو عقابية ناتجة عن استخدامك أو عدم قدرتك على استخدام خدماتنا. لن تتجاوز مسؤوليتنا الإجمالية المبلغ الذي دفعته مقابل الخدمات المعنية.",
  termination: "الإنهاء",
  terminationText: "نحتفظ بالحق في إنهاء أو تعليق وصولك إلى خدماتنا على الفور، دون إشعار مسبق، لأي سبب من الأسباب، بما في ذلك انتهاك شروط الخدمة هذه.",
  governingLaw: "القانون الحاكم",
  governingLawText: "تخضع هذه الشروط وتفسر وفقًا لقوانين مصر، دون النظر إلى أحكام تنازع القوانين.",
  changesToTerms: "التغييرات على الشروط",
  changesToTermsText: "نحتفظ بالحق في تعديل هذه الشروط في أي وقت. سنخطر المستخدمين بأي تغييرات جوهرية عن طريق نشر شروط الخدمة الجديدة على هذه الصفحة.",
  contactUsTermsText: "إذا كان لديك أي أسئلة حول شروط الخدمة هذه، يرجى الاتصال بنا:",

  // Blog Section
  blog: 'المدونة',
  blogTitle: 'Software Development Insights',
  blogTitleAr: 'رؤى وموارد تطوير البرمجيات',
  blogDescription: 'Expert articles on software debugging, custom development, and cloud services for Egyptian businesses.',
  blogDescriptionAr: 'مقالات خبيرة حول تصحيح البرمجيات، التطوير المخصص، والخدمات السحابية للشركات المصرية.',
  readMore: 'اقرأ المزيد',
  backToBlog: 'العودة إلى المدونة',
  articleNotFound: 'المقال غير موجود',
  relatedArticles: 'مقالات ذات صلة',

  // Service Pages
  whatWeOffer: 'ما نقدمه',
  whyChooseDebug: 'لماذا تختار Debug؟',
  getQuote: 'احصل على عرض أسعار',
  relatedServices: 'خدمات ذات صلة',
};